import { AxiosResponseHeaders } from 'axios';
import {
  ConsolidatedTransactionDetailsPrint,
  ConsolidatedTransactionDetailsPrintResponseDTO,
} from '../../entities/ConsolidatedTransaction/ConsolidatedTransactionDetailsPrintResponseDTO';

const ConsolidatedTransactionDetailsPrintResponseDTOtoConsolidatedTransactionDetailsPrintAdapter = (
  response: ConsolidatedTransactionDetailsPrintResponseDTO,
  headers?: AxiosResponseHeaders,
): ConsolidatedTransactionDetailsPrint => {
  if (!response.body) {
    throw Error();
  }

  return {
    report: response.body.report,
  };
};

export { ConsolidatedTransactionDetailsPrintResponseDTOtoConsolidatedTransactionDetailsPrintAdapter };
